import { CreateProjectCheckpoint } from '../../../domain/projectCheckpoints/createProjectCheckpoint';
import { UpdateTaskStatus } from '../../../domain/projectCheckpoints/updateTaskStatus';
import { ProjectCheckpointsAdapter } from '../../adapters/projectCheckpoints/projectCheckpointsAdapters';
import {
    ProjectCheckpointsListDTO,
    TasksModelDTO,
} from '../../http/dtos/projectCheckpoints/projectCheckpointListDTO';
import httpClient from '../../http/httpClient';

export const ProjectCheckpointsRepository = {
    GetProjectCheckpointsList: (projectId: string) => {
        return httpClient
            .get(
                `/project-checkpoints/checkpoints-by-project?projectId=${projectId}`
            )
            .then((response: ProjectCheckpointsListDTO[]) =>
                ProjectCheckpointsAdapter.getProjectCheckpointsListAdapter(response)
            );
    },

    GetTasksCheckpoint: (id: string) => {
        return httpClient
            .get('/project-checkpoints/tasks-by-project-checkpoints/' + id)
            .then((response: TasksModelDTO) =>
                ProjectCheckpointsAdapter.getTasksProjectCheckpointsAdapter(response)
            );
    },

    CreateProjectCheckpoint: (newProjectCheckpoint: CreateProjectCheckpoint) => {
        return httpClient
            .post('/project-checkpoints', newProjectCheckpoint)
            .then((response) => response);
    },

    UpdateTaskStatus: (id: number, newStatus: UpdateTaskStatus) => {
        return httpClient
            .put('/project-checkpoints/update-task-status/' + id, newStatus)
            .then((response) => response);
    },
};
